/* file description */
import React from 'react';
import RoleSelectMemo from '../../component/RoleSelect';
import RoleSelectRenderMemo from '../../component/RoleSelect/render';
import { VALUE_TYPES, COLUMN_FROM } from '../consts';
import { TransformNalmalType2TableColumn } from '../type';
import { Api as FetchAPI } from '@/utils';

export const transformBoulderaiRole2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
}) => {
  targetColumn.valueType = VALUE_TYPES.SELECT;

  targetColumn.renderFormItem = () => {
    return <RoleSelectMemo field={field} FetchAPI={FetchAPI} />;
  };
  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    const { setViewValue } = entity;
    return <RoleSelectRenderMemo field={field} FetchAPI={FetchAPI} targerValue={targerValue} setViewValue={setViewValue} />;
  };

  return targetColumn;
};
